import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { conceptosDto } from '../models/carga-fc.dto';

@Injectable({
  providedIn: 'root'
})
export class OcConceptosService {
  private apiUrl = ``;
  private entity = `oc-conceptos`;

  constructor(private http: HttpClient) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  }

  getConcepto(tipo: string, num: number, renglon: number) {
    return this.http.get<conceptosDto>(`${this.apiUrl}/${tipo}/${num}/${renglon}`).pipe(
    map((response:any) => response[0]) 
  );
  }
}
